<template>
  <div class="thank">
    <div class="thank__overlay" @click.self="close">
      <div class="thank__content">
        <div class="thank__top">
          <img src="../assets/img/thank-icon.svg" alt="" class="thank__top-img">
          <p class="thank__top-title">Спасибо за регистрацию!</p>
        </div>
        <p class="thank__text">Ждём Вас на мероприятии</p>
        <p class="thank__name">{{ eventTitle }}</p>
        <div class="thank__btns">
          <button @click="goToOrders" class="thank__btn secondary">Перейти к моим заказам</button>
          <button @click="close" class="thank__btn">Понятно</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
axios.defaults.headers.common['X-API-KEY'] = 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1';

export default {
  name: "Thank",
  props: {
    eventTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    goToOrders() {
      this.$emit("close");
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.close();
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  },
};
</script>